import React, { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { postJSON } from "@/lib/api";

const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NewsletterForm() {
  const { t, lang } = useLang();
  const f = t.footer;
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [company, setCompany] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!emailRe.test(email)) return setError(lang === "fr" ? "Adresse e-mail invalide." : "Invalid email address.");
    if (!consent) return setError(lang === "fr" ? "Merci de cocher le consentement." : "Please tick the consent box.");
    setStatus("loading");
    try {
      await postJSON("/newsletter/subscribe", { email, consent, lang, company });
      setStatus("success");
    } catch (err) {
      setStatus("idle");
      setError(err.message || (lang === "fr" ? "Une erreur est survenue." : "Something went wrong."));
    }
  };

  if (status === "success") {
    return (
      <div className="mt-6" data-testid="newsletter-success">
        <p className="text-sm font-heading font-bold text-white">{f.newsletterTitle}</p>
        <p className="mt-3 rounded-xl border border-nek-teal-100/30 bg-nek-teal/15 p-4 text-sm text-white/90">{f.newsletterSuccess}</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="mt-6" noValidate>
      <p className="text-sm font-heading font-bold text-white">{f.newsletterTitle}</p>
      <p className="mt-1 max-w-sm text-xs leading-relaxed text-white/60">{f.newsletterText}</p>
      <input type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" value={company} onChange={(e) => setCompany(e.target.value)} className="hidden" />
      <div className="mt-3 flex max-w-sm gap-2">
        <input
          type="email"
          data-testid="newsletter-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={f.newsletterPlaceholder}
          aria-label={f.newsletterPlaceholder}
          className="min-w-0 flex-1 rounded-lg border border-white/15 bg-white/5 px-3 py-2.5 text-sm text-white placeholder:text-white/40 focus:border-nek-teal-100 focus:outline-none"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          data-testid="newsletter-submit"
          className="shrink-0 rounded-lg bg-nek-teal px-4 py-2.5 text-sm font-heading font-bold text-white transition-colors hover:bg-nek-teal-800 disabled:opacity-60"
        >
          {status === "loading" ? "…" : f.newsletterButton}
        </button>
      </div>
      <label className="mt-3 flex max-w-sm items-start gap-2 text-xs leading-relaxed text-white/60">
        <input type="checkbox" data-testid="newsletter-consent" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        <span>{f.newsletterConsent}</span>
      </label>
      {error && <p className="mt-2 text-xs text-red-300" data-testid="newsletter-error">{error}</p>}
    </form>
  );
}
